import { GraphQL } from "@graphql/graphQL";
import { DuplicateApplianceListMutation, DuplicateApplianceListMutationVariables } from "@models/graphql";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

const defaultDuplicateApplianceListOptions: MutationHookOptions<DuplicateApplianceListMutation, DuplicateApplianceListMutationVariables> = {

};

export const useDuplicateApplianceList = (options?: MutationHookOptions<DuplicateApplianceListMutation, DuplicateApplianceListMutationVariables>) => {
    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: DuplicateApplianceListMutation;
        error?: ApolloError;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<DuplicateApplianceListMutation, DuplicateApplianceListMutationVariables>(GraphQL.duplicateApplianceList);

    const duplicateApplianceList = async (variables: DuplicateApplianceListMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultDuplicateApplianceListOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return {
                data: response.data,
                error: response.errors
            };
        } catch (error) {
            setHookState({
                error,
                isLoading: false
            });

            return {
                error
            };
        }
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        duplicateApplianceList
    };
};
